import { auth } from "../plugins/firebase";

// REST
import { RepositoryFactory } from "../repository/RepositoryFactory";
const ApiRepository = RepositoryFactory.get("api");

export const loginToFirebase = async function (shopId, lineToken) {
  // カスタムトークン作成 (admin)
  // - サーバでは lineToken を認証 -> userId 取得
  // - userId を基にカスタムトークン作成
  const customToken = await _getCustomToken(shopId, lineToken);
  // console.log(`customToken=${customToken}`);

  // Firebase auth ログイン
  return _signInWithCustomToken(customToken);
};

export const _getCustomToken = async function (shopId, lineToken) {
  const res = await ApiRepository.getCustomToken(shopId, lineToken);
  // console.log(`res=${JSON.stringify(res)}`);
  return res.data.customToken;
};

export const _signInWithCustomToken = async function (customToken) {
  // Firebase auth ログイン (カスタムトークン)
  // https://firebase.google.com/docs/auth/admin/create-custom-tokens?hl=ja
  return auth.signInWithCustomToken(customToken);
};

export const getAccessToken = async function () {
  return auth.currentUser?.getIdToken() ?? "";
}
